import React from 'react';
import '../../src/bootstrap.css';
import Plans from '../components/Plans'


const Services = () => {
 return (
  <>
   <h3 className="text-dark text-center my-3">Welcome to our Services</h3>
   {/* <HeroSection /> */}
   {/* <Cards /> */}
   < Plans />
  </>
 )
}

export default Services